import { Card, CardActionArea, Typography } from '@material-ui/core';
import { ChevronIcon } from 'components/Icons';
import { AssembleiaAssociadoRoutePath } from 'library/Routes';
import moment from 'moment';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { IAssembleiaAssociado } from 'store/modules/AssembleiasAssociadoReducer';
import { history } from 'store/Store';
import { useStyles } from './styles';

interface ICardProps {
  evento: IAssembleiaAssociado
}

const CartaoEvento = ({ evento }: ICardProps) => {
  const {t} = useTranslation();
  const classes = useStyles();
  const handleClick = useCallback(() => {
    history.push(AssembleiaAssociadoRoutePath.split(':id').join(evento.id.toString()));
  }, [evento]);

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={handleClick} className={classes.clickArea}>
        <ChevronIcon className={classes.iconChevron} />
        <hgroup className={classes.titleGroup}>
          <Typography component="h1" className={classes.tipo}>
            {evento.tipo}
          </Typography>
          <Typography component="h2" className={classes.nome}>
            {evento.nome}
          </Typography>
        </hgroup>
        <div style={{flex: 1}}></div>
        {typeof evento.dataEvento === 'string' && (
          <React.Fragment>
            <Typography component="h1" className={classes.titleData}>
              {t(`TelaInicialAssociado.cartaoEvento.dataInicio`)}
            </Typography>
            <Typography component="h1" className={classes.currentData}>
              {moment(evento.dataEvento).format('DD/MM/YYYY - HH:mm')}
            </Typography>
          </React.Fragment>
        )}
        {typeof evento.dataEventoFim === 'string' && (
          <React.Fragment>
            <Typography component="h1" className={classes.titleData}>
              {t(`TelaInicialAssociado.cartaoEvento.dataFim`)}
            </Typography>
            <Typography component="h1" className={classes.currentData}>
              {moment(evento.dataEventoFim).format('DD/MM/YYYY - HH:mm')}
            </Typography>
          </React.Fragment>
        )}
      </CardActionArea>
    </Card>
  );
};

export default CartaoEvento;
